// 时光机接口
import { get } from '~/assets/js/api/methods'

import apiList from '~/api.config.js'
const { testwikidatacenter, homeClient } = apiList
// testwikidatacenter 服务端 homeClient 客户端
export default axios => ({
  init: (params = {}) => get(axios, `${testwikidatacenter}/wikifxweb-v1/webprt/index/init-v1`, params), // 初始化 /wikifxweb-v1/webprt/index/init-v1
  Timepaging: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/webprt/index/page-v1`, params), // 时光机分页 /wikifxweb-v1/webprt/index/page-v1
  TimeScreening: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/webprt/index/filter-v1`, params), // 时光机筛选 /wikifxweb-v1/webprt/index/filter-v1
  // 详情页初始化 /wikifxweb-v1/live/calendar/index/more-v1
  more: (params = {}) => get(axios, `${homeClient}/wikifxweb-v1/live/calendar/index/more-v1`, params)
})
